import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd6fcd6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd6fcd6a', __exports__)) {
    console.log('reload')
    api.reload('bd6fcd6a', __exports__)
  }
  
}


export default __exports__